const STORAGE_KEY = 'falcon-planner:assign-users-shell';

export type AssignUsersShell = 'drawer' | 'floating';

const DEFAULT_SHELL: AssignUsersShell = 'drawer';

function normalize(value: unknown): AssignUsersShell {
  return value === 'floating' ? 'floating' : 'drawer';
}

/** Load Assign users shell preference for this tab session. */
export function loadAssignUsersShell(): AssignUsersShell {
  if (typeof window === 'undefined') return DEFAULT_SHELL;
  try {
    return normalize(window.sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return DEFAULT_SHELL;
  }
}

/** Persist Assign users shell preference for this tab session. */
export function saveAssignUsersShell(shell: AssignUsersShell): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, shell);
  } catch {
    // ignore quota / private mode
  }
}
